import {getDataObject} from '../helpers';
import api from '@/api';
import {testVoter} from '../helpers';

const state = {
  response: {
    status: 0
  }
};

const getters = {
  confirmResponse: state => state.response
};

const actions = {
  // Get the content so user can review content to go into proxy
  getProxyContent({commit, dispatch, rootState, rootGetters}) {
    const data = getDataObject(rootState);
    const token = rootGetters.token;
    const isPreviewMode = rootState.previewMode;

    let voterToken = null;
    if (isPreviewMode) {
      voterToken = btoa(testVoter.email);
    } else {
      voterToken = token;
    }

    api
      .getProxyContent(data, voterToken)
      .then(res => {
        if (!res.status === 200) {
          commit('SET_PROXY_CONTENT_RESPONSE', res);
          return dispatch(
            'setError',
            {
              status: res.status,
              message: res.statusText
            },
            {root: true}
          );
        }
        return commit('SET_PROXY_CONTENT_RESPONSE', res);
      })
      .catch(err => {
        const errObj = {status: err.status, message: err.statusText};
        commit('SET_PROXY_CONTENT_RESPONSE', err);
        return dispatch('setError', errObj, {root: true});
      });
  },

  // Reset the proxy content object
  resetProxyContent({commit}) {
    commit('RESET_PROXY_CONTENT_RESPONSE');
  }
};

const mutations = {
  SET_PROXY_CONTENT_RESPONSE(state, response) {
    state.response = response;
  },
  RESET_PROXY_CONTENT_RESPONSE(state) {
    state.response = {status: 0};
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
